import axios from "axios";
import { selector, atom, useResetRecoilState } from "recoil";

// import { get } from "@auth0/nextjs-auth0/dist/auth0-session/get-config";

const userInfo = atom({
  key: "UserInfo",
  default: {
    test: "name",
  },
});

export const fetchUserDetails = selector({
  key: "currentUserDetails",
  get: async ({ get }) => {
    const { data } = await axios.get("/api/users/me");

    return data;
  },
});

export const userRolesAtom = selector({
  key: "CurrentUserRoles",
  get: async ({ get }) => {
    const user = get(fetchUserDetails);

    return user.role;
  },
});

export const userOrgRole = selector({
  key: "CurrentUserOrgRole",
  get: async ({ get }) => {
    const user = get(fetchUserDetails);

    return user.organizationUser[0].role;
  },
});
